import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { PolicyDetails } from '../../../../models/Policy';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';


export interface PolicyActivateConfirmDialogData {
  policy: PolicyDetails;
  isPolicyActive: boolean;
  isPolicyInUse: boolean;
}

@Component({
  selector: 'app-deactivate-policy-dialog',
  templateUrl: './deactivate-policy-dialog.component.html',
  styleUrls: ['./deactivate-policy-dialog.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule, 
    MatDialogModule,
    CommonModule
  ]
})
export class DeactivatePolicyDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PolicyActivateConfirmDialogData,
    public dialogRef: MatDialogRef<DeactivatePolicyDialogComponent>
  ) { }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }
}